const Spinner = () => {
  return (
    <div id="loader">
      <img alt="TetherAll logo" className="appLogo" src="/assets/imgs/tetherall_icon.png" />
    </div>
  );
};

export default Spinner;
